import React, { Component, useState } from 'react';
import Dropdown from '../Components/Dropdown';
import {
  M3H,
  LS,
  TOTAL_P,
  STATIC_P,
  NOISE_1m,
  NOISE_3m,
} from '../Services/ValueTransform';

const ReporForm = ({ onSearch, form, handleForm }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (
      !Number(form.volume) ||
      !Number(form.pressure) ||
      form.volume <= 0 ||
      form.pressure <= 0
    )
      return;
    onSearch(form);
  };

  return (
    <div class='flex flex-column'>
      <div class='max-w-[500px] w-full px-6'>
        <form class='space-y-3'>
          <div
            className='flex flex-row'
            style={{ rowGap: 10, alignItems: 'center' }}
          >
            <div
              className='flex flex-column'
              style={{ width: 170, alignItems: 'center' }}
            >
              <span style={{ display: 'block', width: 70 }}>Volume</span>
              <input
                style={{ flex: 1, height: 37 }}
                // type='number'
                // defaultValue={0}
                tabIndex={0}
                class='form-input rounded-md !h-[35px] bg-white border !border-[#ced4da] focus:!border-custom'
                required=''
                onChange={(e) => {
                  if (isNaN(e.target.value) && e.target.value !== '') return;
                  handleForm(
                    e.target.value !== '' ? Number(e.target.value) : '',
                    'volume'
                  );
                }}
                value={form.volume}
              />
            </div>
            <div style={{ width: 80, marginLeft: 20 }}>
              <Dropdown
                label={'Volume'}
                options={{ [M3H]: 'm3/h', [LS]: 'l/s' }}
                defaultValue={form.volumeType}
                onChange={(value) => {
                  handleForm(Number(value), 'volumeType');
                }}
              />
            </div>
            <div style={{ width: 80, marginLeft: 20 }}>
              <input
                type='radio'
                class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                name='presst'
                checked={form.pressureType === STATIC_P}
                onChange={(e) => handleForm(STATIC_P, 'pressureType')}
              />
              <label for='presst' class='ml-1 relative top-[2px]'>
                Static
              </label>
            </div>
          </div>
          <div
            className='flex flex-row'
            style={{ rowGap: 10, alignItems: 'center' }}
          >
            <div
              className='flex flex-column'
              style={{ width: 170, alignItems: 'center' }}
              tabIndex={1}
            >
              <span style={{ display: 'block', width: 70 }}>Pressure</span>
              <input
                style={{ flex: 1, height: 37 }}
                // type='number'
                // defaultValue={0}
                class='form-input rounded-md !h-[20px] bg-white border !border-[#ced4da] focus:!border-custom'
                required=''
                onChange={(e) => {
                  if (isNaN(e.target.value) && e.target.value !== '') return;
                  handleForm(
                    e.target.value !== '' ? Number(e.target.value) : '',
                    'pressure'
                  );
                }}
                value={form.pressure}
              />
            </div>
            <div style={{ width: 80, marginLeft: 20 }}>
              <Dropdown
                label={'Pressure'}
                options={{ 1: 'Pa' }}
                defaultValue={1}
              />
            </div>
            <div style={{ width: 80, marginLeft: 20 }}>
              <input
                type='radio'
                class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                name='presst'
                checked={form.pressureType === TOTAL_P}
                onChange={(e) => handleForm(TOTAL_P, 'pressureType')}
              />
              <label for='presst' class='ml-1 relative top-[2px]'>
                Total
              </label>
            </div>
          </div>
          <div style={{ marginTop: 25 }}>
            <button
              type='button'
              class='btn-custom py-2'
              onClick={handleSubmit}
            >
              Search
            </button>
          </div>
        </form>
      </div>
      <div class='max-w-[500px] w-full px-6'>
        <form class='space-y-3'>
          <div className='flex flex-row' style={{ rowGap: 10 }}>
            <div
              className='flex flex-column'
              style={{ width: 270, alignItems: 'center' }}
            >
              <span style={{ display: 'block', width: 70 }}>Noise</span>
              <div style={{ width: 200, marginLeft: 20 }}>
                <Dropdown
                  label={'Noise'}
                  options={{ [NOISE_1m]: 'dBA @ 1m', [NOISE_3m]: 'dBA @ 3m' }}
                  defaultValue={form.noise}
                  width={200}
                  onChange={(value) => handleForm(Number(value), 'noise')}
                />
              </div>
            </div>
          </div>
          <div className='flex flex-row' style={{ rowGap: 10 }}>
            <div
              className='flex flex-column'
              style={{ width: 270, alignItems: 'center' }}
            >
              <span style={{ display: 'block', width: 70 }}>Poles</span>
              <div style={{ width: 200, marginLeft: 20 }}>
                <Dropdown
                  label={'Poles'}
                  options={{ 1: 'Any', 2: '2', 4: '4', 6: '6' }}
                  defaultValue={form.poles}
                  width={200}
                  onChange={(value) => handleForm(Number(value), 'poles')}
                />
              </div>
            </div>
          </div>
          {/* <div
            className='flex flex-column'
            style={{ width: 400, alignItems: 'center' }}
          >
            <span style={{ display: 'block', width: 120 }}></span>
            <div
              className='flex border !border-[#ced4da]'
              style={{
                rowGap: 10,
                flexDirection: 'column',
                marginTop: 10,
              }}
            >
              <div style={{ width: 130, marginLeft: 20, paddingTop: 5 }}>
                <input
                  type='radio'
                  class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                  name='dba'
                  checked={form.noise === NOISE_1m}
                  onChange={(e) => handleForm(NOISE_1m, 'noise')}
                />
                <label for='sign' class='ml-1 relative top-[2px]'>
                  dBA @ 1m
                </label>
              </div>
              <div style={{ width: 120, marginLeft: 20, paddingBottom: 5 }}>
                <input
                  type='radio'
                  class='form-checkbox border-[#ced4da] rounded focus:ring-transperent focus:outline-none h-4 w-4 text-custom'
                  name='dba'
                  checked={form.noise === NOISE_3m}
                  onChange={(e) => handleForm(NOISE_3m, 'noise')}
                />
                <label for='sign' class='ml-1 relative top-[2px]'>
                  dBA @ 3m
                </label>
              </div>
            </div>
          </div> */}
        </form>
      </div>
    </div>
  );
};
export default ReporForm;
